import { AuthenticationCommandResponses } from "./models/authenticationCommandResponse";
import { CommandResponse } from "./models/commandResponse";
import { processMessage } from "./messageHandler";
import {Logger} from "../utils/logging";

export const dialogHeight = 598;
export const dialogWidth = 200;

export class ClientCommService {

  /**
   * Adds necessary event handler for authentication window communication
   */
  static initializeCommunication() {
    if (window.location === window.parent.location) {
      // not in an iframe
      /* istanbul ignore next */
      return;
    }
    window.addEventListener("message", eventListenerCallback, false);
  }

  /**
   * Method that closes a modal dialog for portal navigation
   */
  static async closeNavigationDialog () {
    const response = new CommandResponse(AuthenticationCommandResponses.ClosePortalNavigation, {
      dialogHeight,
      dialogWidth,
      success: true
    });
    Logger.debug("clientCommService.processMessage", "message response", response);
    window.parent.postMessage(response, "*");
  }

  /**
   * Requests that the parent page navigate to an address
   * @param {string} to - contains the url to navigate to
   */
  static navigateParent(to) {
    const response = new CommandResponse(AuthenticationCommandResponses.ParentNavigation, {
      to,
      success: true
    });
    Logger.debug("clientCommService.processMessage", "message response", response);
    window.parent.postMessage(response, "*");
  };

  /**
   * Method that exposes a modal dialog for portal navigation
   */
  static async showNavigationDialog () {
    const response = new CommandResponse(AuthenticationCommandResponses.PortalNavigation, {
      dialogHeight,
      dialogWidth,
      success: true
    });
    Logger.debug("clientCommService.processMessage", "message response", response);
    window.parent.postMessage(response, "*");
  }
}

export const eventListenerCallback = async (message) => {
  await processMessage(message);
};
